import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import FormikSelectField from "../../../../shared/components/FormikSelectField";
import { ErrorMessage } from "formik";

const CategoryRoutingRules = ({values, setFieldValue, adminGroup, employees, handleAdminGroupChange, initialRouting,}) => {

  const [localAdminGroup, setLocalAdminGroup] = useState(null);
  const [localAssignedTo, setLocalAssignedTo] = useState(null);
  const [initialized, setInitialized] = useState(false);

  //  Initialize once on mount
  useEffect(() => {
    if (!initialized && initialRouting) {
      if (initialRouting.adminGroup) {
        setLocalAdminGroup(initialRouting.adminGroup);
        // trigger employee fetch
        handleAdminGroupChange(
          { target: { value: initialRouting.adminGroup } },
          setFieldValue
        );
      }
      if (initialRouting.assignedTo) {
        setLocalAssignedTo(initialRouting.assignedTo);
      }
      setInitialized(true);
    }
  }, [initialized, initialRouting, handleAdminGroupChange, setFieldValue]);

  // Whenever user changes admin group manually
  const onAdminGroupChange = (value) => {
    setLocalAdminGroup(value);
    setFieldValue("routing.adminGroup", value);
    handleAdminGroupChange({ target: { value } }, setFieldValue);
  };

  //  Whenever user changes assigned to manually
  const onAssignedToChange = (value) => {
  setLocalAssignedTo(value);
  setFieldValue("routing.assignedTo", value);

  // Auto-detect group & sync adminGroup
  const selectedEmp = employees.find((e) => e.id === value);

  if (selectedEmp?.group_id) {
    setLocalAdminGroup(selectedEmp.group_id);
    setFieldValue("routing.adminGroup", selectedEmp.group_id);

    // Load employees for this admin group
    handleAdminGroupChange(
      { target: { value: selectedEmp.group_id } },
      setFieldValue
    );
  }
};


  // When employees update (after API), auto-assign if only one match & not user-selected yet
  useEffect(() => {
    if (employees?.length && !localAssignedTo && initialRouting?.assignedTo) {
      setLocalAssignedTo(initialRouting.assignedTo);
      setFieldValue("routing.assignedTo", initialRouting.assignedTo);
    }
  }, [employees]);

  return (
    <Card className="mb-5">
      <Card.Header>Routing Rule Configuration</Card.Header>
      <Card.Body>
        <Row className="g-3 align-items-center">
          <Col md={12}>
            <div className="col-md-6 my-auto">
              <div style={{ fontSize: "1rem" }}>
                <label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={values.isRouting}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setFieldValue("isRouting", checked);

                      if (checked) {
                        // Load group 24 employees automatically
                        handleAdminGroupChange({ target: { value: 24 } }, setFieldValue);
                        setLocalAdminGroup(24);
                        setFieldValue("routing.adminGroup", 24);
                      } else {
                        setLocalAdminGroup(null);
                        setLocalAssignedTo(null);
                        setFieldValue("routing.adminGroup", null);
                        setFieldValue("routing.assignedTo", null);
                      }
                    }}

                  />{" "}
                  Enable Routing Rule
                </label>
              </div>
            </div>
          </Col>

          {values.isRouting && (
            <>
              <Col md={6}>
                <label className="form-label">Admin Group</label>
                <FormikSelectField
                  name="routing.adminGroup"
                  value={localAdminGroup || ""}
                  onChange={(name, value) => onAdminGroupChange(value)}
                  placeholder="Select a user group"
                >
                  {adminGroup.map((admin) => (
                    <option key={admin.group_id} value={admin.group_id}>
                      {admin.group_name}
                    </option>
                  ))}
                </FormikSelectField>
              </Col>

              <Col md={6}>
                <label className="form-label">Assigned To</label>
                <FormikSelectField
                  name="routing.assignedTo"
                  value={localAssignedTo || ""}
                  onChange={(name, value) => onAssignedToChange(value)}
                  placeholder="Select an employee"
                >
                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.emp_name}
                    </option>
                  ))}
                </FormikSelectField>
              </Col>

              <ErrorMessage
                name="routing"
                component="div"
                className="error-text"
              />
            </>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CategoryRoutingRules;
